<template>
  <v-app id="app" :class="{ landscape, portrait }">
    <v-app-bar app>
      <v-app-bar-nav-icon v-if="$route.name !== 'home'" @click="$router.back()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>MozDesigner Viewer</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container fluid fill-height>
        <keep-alive include="select-block,view-block">
          <router-view/>
        </keep-alive>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    const portrait = /^portrait/.test(screen.orientation.type),
            landscape = !portrait;
    return {
      landscape,
      portrait,
    };
  },
  mounted() {
    screen.orientation.addEventListener('change', () => {
      this.portrait = /^portrait/.test(screen.orientation.type);
      this.landscape = !this.portrait;
    });
  },
}
</script>

<style lang="scss">
html, body {
  height: 100vh;
  width: 100vw;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
.v-main {
  min-height: 100%;
}
.fill-height {
  height: 100%;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
